import React from 'react'
import Select, { components } from 'react-select'
import getDayKey from '../../functions/getDayKey'
import getMomentDateObj from '../../functions/getMomentDateObj'
import getMovieTitle from '../../functions/getMovieTitle'
import getShowtimeKey from '../../functions/getShowtimeKey'
import getTranslation from '../../functions/getTranslation'
import checkForQuickTicketSelectOptions from '../../functions/checkForQuickTicketSelectOptions'

const BuyTicketMovieTitles = ({movies, translation, dateNow, moviesOrder, state, changeMovieTitle, selectSettings}) => {
    const { timezone } = translation
    const { currentMovieOption, currentMovieDate, currentMovieShowtime, currentCinema } = state
    let options = []
    let moviesArray = moviesOrder
    const movieTitles = []

    const Placeholder = (props) => {
        return (
            <components.Placeholder {...props}/>
        );
    };

    const onChange = (movie) => {
        if(!movie) {
            const value = ''
            const option = ''
            changeMovieTitle(value, option)
        } else {
            const {value} = movie
            const option = movie
            changeMovieTitle(value, option)
        }
    }

    moviesArray.map((movieID) => {
        const movie = movies[movieID] 
        const currentTitle = getMovieTitle(movie)           

        movieTitles.push(currentTitle)
    })

    const sortedTitles = movieTitles.sort()

    moviesArray = _.filter(moviesArray, movieID => {
        const currentMoviePerformances = movies[movieID].performances
        const filteredPerformances = _.filter(currentMoviePerformances, performance => {
            let hasAttribute = checkForQuickTicketSelectOptions(currentMovieDate, currentMovieShowtime, currentCinema, performance, dateNow, timezone)
            const performanceDate = getMomentDateObj(performance.timeUtc, timezone)
            
            if(!_.contains(hasAttribute, 'false')) {
                return dateNow.isBefore(performanceDate)
            }
        })

        return filteredPerformances.length !== 0
    })
    
    sortedTitles.map(sortedTitle => {
        moviesArray.map((movieID) => {
            const movie = movies[movieID]
            const currentTitle = getMovieTitle(movie)      

            if(currentTitle === sortedTitle) {
                const value = movieID
                const label = currentTitle
        
                options.push({value,label})
            }
        })
    })

    return <Select {...selectSettings}
                options={options}
                components={{ Placeholder }}
                placeholder={getTranslation('selectMovie', translation)}
                value={currentMovieOption}
                onChange={(value) => onChange(value)}
                menuPlacement={'top'}
            />
} 

export default BuyTicketMovieTitles